import { Subject } from "rxjs";
import { map } from "rxjs/operators";

import { InjectorInterface } from "./InjectorInterface";
import MutationObserverInjector from "./MutationObserverInjector";

interface IntersectionObserverInjectorConfig {
    rootMargin?: string;
    threshold?: number | number[];
}

class IntersectionObserverInjector implements InjectorInterface {
    private io: IntersectionObserver;
    public targets$ = new Subject<Element>();
    private foundElements = new WeakSet();
    constructor(
        IntersectionObserverCls: typeof IntersectionObserver,
        private mutationInjector: MutationObserverInjector,
        config?: IntersectionObserverInjectorConfig
    ) {
        this.io = new IntersectionObserverCls(this.intersectionCalback, {
            rootMargin: config?.rootMargin,
            threshold: config?.threshold,
        });
    }
    start(): void {
        this.mutationInjector.targets$
            .pipe(
                map((el) => {
                    this.io.observe(el);
                })
            )
            .subscribe();
        this.mutationInjector.start();
    }
    stop(): void {
        this.mutationInjector.stop();
        this.io.disconnect();
    }
    intersectionCalback = (entries: IntersectionObserverEntry[]): void => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const { target } = entry;
                if (!this.foundElements.has(target)) {
                    this.foundElements.add(target);
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                    this.targets$.next(target);
                }
            }
        });
    };
}

export default IntersectionObserverInjector;
